import { __assign, __awaiter, __generator, __rest, __spreadArray } from "tslib";
import { INIT_STATUS } from "@/const/index";
import { SCENE_CONFIG } from "@/const/config";
import { setWebpSupportMark, genFormatUrl } from "@/utils/tools";
import { getNestedData } from "@/utils/index";
import { arrayFindPolyfill, objectAssignPolyfill, objectValuesPolyfill } from "./utils/es5Tool";
import { isServer } from "./utils/env";
import { getGlobalConfig, setGlobalConfig } from "./utils/globalConfig";
var DirectiveType;
(function (DirectiveType) {
    DirectiveType["DEFAULT"] = "default";
    DirectiveType["BACKGROUND"] = "background";
})(DirectiveType || (DirectiveType = {}));
var eImageX = {
    initStatus: INIT_STATUS.READY
};
// 初始化缓存对象
var imageXUrlCache = {};
eImageX.initStatus = INIT_STATUS.READY;
var pmsStatus;
eImageX.initPms = new Promise(function (resolve, reject) {
    pmsStatus = [resolve, reject];
});
eImageX.init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var resolve, reject, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (pmsStatus == undefined || eImageX.initStatus !== INIT_STATUS.READY)
                    return [2 /*return*/];
                resolve = pmsStatus[0], reject = pmsStatus[1];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                eImageX.initStatus = INIT_STATUS.DOING;
                return [4 /*yield*/, setWebpSupportMark()];
            case 2:
                _a.sent();
                eImageX.initStatus = INIT_STATUS.DONE;
                resolve && resolve();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                reject && reject();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
// 公共替换方法
eImageX.processUrls = function (scene, urls, config) {
    var sceneConfig = SCENE_CONFIG[scene];
    // 自定义场景
    if (scene == 'custom') {
        var defaultConfig = { type: '2', q: '80' };
        sceneConfig = __assign(__assign({}, defaultConfig), config);
    }
    else {
        // 配置场景
        if (!sceneConfig) {
            console.error("\n \u5F53\u524D\u7248\u672Cimagex\u4E0D\u652F\u6301\u573A\u666F\u3010".concat(scene || ' ', "\u3011\u76F4\u63A5\u4F7F\u7528\u9ED8\u8BA4\u573A\u666F\u3010Default\u3011\uFF0C\u5982\u6709\u9700\u6B63\u5E38\u4F7F\u7528\u529F\u80FD \n \u3010\u8BE6\u89C1 https://fe.xiaoe-tools.com/portal/docs/imagex/imagex.html \u3011,\u5982\u679C\u6587\u6863\u5185\u573A\u666F\u8868\u683C\u6709\u5BF9\u5E94\u573A\u666F\u9700\u8981\u8FDB\u884C\u6A21\u677Fimagex\u5347\u7EA7\u5230\u5BF9\u5E94\u7248\u672C"));
            sceneConfig = SCENE_CONFIG['Default'];
        }
        var extraConfig = {
            delUrlParams: !!(config === null || config === void 0 ? void 0 : config.delUrlParams),
            forceNoWebp: !!(config === null || config === void 0 ? void 0 : config.forceNoWebp),
        };
        sceneConfig = __assign(__assign({}, sceneConfig), extraConfig);
    }
    if (Array.isArray(urls)) {
        return urls.map(function (url) { return genFormatUrl(url, sceneConfig); });
    }
    return genFormatUrl(urls, sceneConfig);
};
// 同步方法（能力有损，在【initPms初始化完成前】异步配置返回前就返回处理后链接，期间使用兜底能力）
eImageX.sync = function (scene, urls, config) {
    if (config === void 0) { config = {}; }
    eImageX.init();
    return eImageX.processUrls(scene, urls, config);
};
// 异步方法（等待【initPms初始化完成】异步配置返回后返回对应内容）
eImageX.async = function (scene_1, urls_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([scene_1, urls_1], args_1, true), void 0, function (scene, urls, config) {
        if (config === void 0) { config = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    eImageX.init();
                    return [4 /*yield*/, eImageX.initPms];
                case 1:
                    _a.sent();
                    return [2 /*return*/, eImageX.processUrls(scene, urls, config)];
            }
        });
    });
};
eImageX.directive = function (Vue, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    // 服务端时不处理，客户端业务册会重新进行注册
    if (isServer) {
        return;
    }
    var name = options.name || 'imagex';
    var _directiveFunc = function (el, binding) { return __awaiter(_this, void 0, void 0, function () {
        var _a, scene, url, _b, config, _c, srcAttr, ciConfig, delUrlParams, forceNoWebp, directiveTypeObj, key, src, directiveValues, directiveType, _d, current, lastAttr;
        return __generator(this, function (_e) {
            _a = binding.value, scene = _a[0], url = _a[1], _b = _a[2], config = _b === void 0 ? {} : _b;
            // 第二个参数如果为对象，则表示传入的是配置对象，url默认获取el的src
            if (typeof url != 'string') {
                config = url || {};
                url = el.src;
            }
            // 如果src处理后重新设置src导致再次触发更新则不在进行二次处理
            // @ts-ignore
            if (el.__ImagexSrc == url)
                return [2 /*return*/];
            _c = objectAssignPolyfill({ srcAttr: 'src', ciConfig: {}, delUrlParams: false, forceNoWebp: false }, config), srcAttr = _c.srcAttr, ciConfig = _c.ciConfig, delUrlParams = _c.delUrlParams, forceNoWebp = _c.forceNoWebp;
            directiveTypeObj = binding.modifiers;
            if (!scene) {
                console.error("\n\u5F53\u524D\u4F7F\u7528\u6307\u4EE4\u6A21\u5F0F\uFF0C\u4F46\u65E0\u8BBE\u7F6E\u5BF9\u5E94sense\u573A\u666F\uFF0C\u8BF7\u8BBE\u7F6E\u5BF9\u5E94\u573A\u666F\u793A\u4F8B: (v-".concat(name, "=['avator','https://xxx.com/xxx.png']) \n \u3010\u8BE6\u89C1 https://fe.xiaoe-tools.com/portal/docs/imagex/imagex.html \u3011"));
            }
            key = "".concat(url, "-").concat(JSON.stringify(binding.value));
            imageXUrlCache[key] = imageXUrlCache[key] || eImageX.sync(scene, url, __assign(__assign({}, ciConfig), { delUrlParams: delUrlParams, forceNoWebp: forceNoWebp }));
            src = imageXUrlCache[key];
            directiveValues = objectValuesPolyfill(DirectiveType);
            directiveType = arrayFindPolyfill(directiveValues, function (type) { return directiveTypeObj[type]; });
            if (directiveType === DirectiveType.BACKGROUND) {
                el.style.backgroundImage = "url(".concat(src, ")");
            }
            else {
                _d = getNestedData(el, srcAttr), current = _d[0], lastAttr = _d[1];
                // @ts-ignore
                el.__ImagexSrc = src;
                current[lastAttr] = src;
            }
            return [2 /*return*/];
        });
    }); };
    var _directiveUpdateCallback = function (el, binding) {
        if (binding.value != binding.oldValue) {
            _directiveFunc(el, binding);
        }
    };
    Vue.directive(name, {
        // vue2
        inserted: function (el, binding) { return _directiveFunc(el, binding); },
        update: function (el, binding) { return _directiveUpdateCallback(el, binding); },
        // vue3
        mounted: function (el, binding) { return _directiveFunc(el, binding); },
        updated: function (el, binding) { return _directiveUpdateCallback(el, binding); },
    });
};
// 将html字符串中img src中的链接替换成数据万象
eImageX.replaceAllImg = function (html_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([html_1], args_1, true), void 0, function (html, sence, config) {
        var _a, _b, srcAttr, options;
        if (sence === void 0) { sence = 'richText'; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = config || {}, _b = _a.srcAttr, srcAttr = _b === void 0 ? "src" : _b, options = __rest(_a, ["srcAttr"]);
                    eImageX.init();
                    return [4 /*yield*/, eImageX.initPms];
                case 1:
                    _c.sent();
                    return [2 /*return*/, html.replace(/<img[^>]*>/gi, function (str) {
                            var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
                            var matchInfo = str.match(srcReg);
                            if (Array.isArray(matchInfo) && matchInfo.length > 1) {
                                var newSrc = eImageX.sync(sence, matchInfo[1], options);
                                return str.replace(matchInfo[0], "".concat(srcAttr, "=\"").concat(newSrc, "\""));
                            }
                            else {
                                var content = "".concat(srcAttr, "=\"").concat(eImageX.sync("custom", "https://commonresource-1252524126.cdn.xiaoeknow.com/image/m1ioijik0iys.png"), "\"");
                                return str.replace('<img', "<img ".concat(content));
                            }
                        })];
            }
        });
    });
};
eImageX.getGlobalConfig = getGlobalConfig;
eImageX.setGlobalConfig = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var flag;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                flag = setGlobalConfig(config);
                return [4 /*yield*/, setWebpSupportMark()];
            case 1:
                _a.sent();
                return [2 /*return*/, flag];
        }
    });
}); };
export default eImageX;
